import React, { Component } from 'react'
import { NavLink } from 'react-router-dom'
import { connect } from 'react-redux'

import '../style/home.scss'

import DIDs from '../components/DIDs'
import HostedPBX from '../components/HostedPBX'
import SMS from '../components/SMS'
import Equipment from '../components/Equipment'
import DialingPlan from '../components/DialingPlan'
import Collapse from '../components/Collapse'
import Summary from '../components/Summary'
import HeaderTitle from '../components/HeaderTitle'

//import Checkout from '../components/Checkout'

import { animateScrollToTop } from '../utils/main'
import { sendInBlueCartUpdated, sendInBlueCartDeleted } from '../utils/sendInBlue'
import { setCartCookie, getCartCookie, setCookie, CART_ITEMS_COOKIE_ID } from '../utils/cookies'

import { APP_ENDPOINTS, APP_BASENAME } from '../store/reducers/statics/consts'

import { getPhoneNumbersSum, getHostedPbxSum, getDialingPlansSum, 
    getSmsSum, getEquipmentSum, getEquipmentCount, getAllItemsSummary } from '../store/actions/SummaryActions'
import { setAddedDIDs, setBulkPackagesSelected } from '../store/actions/DIDsActions'
import { setAddOnFeatures, setDialingPlan } from '../store/actions/DialingPlansActions'
import { setEquipmentSelected } from '../store/actions/EquipmentActions'
import { setPbxPlan } from '../store/actions/HostedPbxActions'

class Home extends Component {

    didComponentMount = false;
    state = {
        isSelectedNumTableOpen: false,
        isSelectedEquipmentTableOpen: false,
        isAllExpanded: false,
        expandedKeys: [],
    }

    componentDidMount() {
        this.didComponentMount = true;
        this.setDataInReducersFromCookie();
    }

    onCollapseChange(keys) {
        //const { history } = this.props;
        if(this.state.isAllExpanded) {
            this.setState({
                ...this.state,
                isAllExpanded: !(keys.length <= 1),
                expandedKeys: keys
            })
        }
        if(!keys || keys.length <= 0 || keys.length > 1) {
            //history.push(`/${APP_BASENAME}/`);
            this.historyPush(`/${APP_BASENAME}/`, "VoIP Dialing Shop");
        } else {
            const selected = APP_ENDPOINTS[keys];
            //history.push(`/${APP_BASENAME}/${selected}`);
            this.historyPush(`/${APP_BASENAME}/${selected}`, `VoIP Dialing Shop - ${selected}`);
        }
        animateScrollToTop();
    }

    historyPush(path, title) {
        const { history } = this.props;
        history.push(path);

        var page_name = title.replace(/-|\s/g,"-");
        var properties = {
            'ma_title' : title,
            'ma_url' : window.location.href,
            'ma_path' : window.location.pathname
        }
        //console.log(page_name, properties);
        window.sendinblue && window.sendinblue.page(page_name, properties);
    }

    setDataInReducersFromCookie() {
        try {
            var data = JSON.parse(getCartCookie());
            //console.log("setDataInReducersFromCookie", data);
            this.props.setAddedDIDs(data.DIDsAdded);
            this.props.setBulkPackagesSelected(data.bulkPackagesSelected);
            this.props.setAddOnFeatures(data.AddOnFeatures);
            this.props.setDialingPlan(data.DialingPlan);
            this.props.setEquipmentSelected(data.EquipmentSelected);
            this.props.setPbxPlan(data.HostedPbxPlan);
        } catch (err) {
            //there was no cookie, or cookie wasn't properly formatted as JSON - do nothing
            //console.log(err);
        }
    }

    saveNewDataInCookie(data) {
        if(!this.didComponentMount) return;
        const newData = {
            DIDsAdded: data.DIDsReducer.DIDsAdded,
            bulkPackagesSelected: data.DIDsReducer.bulkPackagesSelected,
            AddOnFeatures: data.DialingPlansReducer.AddOnFeatures,
            DialingPlan: data.DialingPlansReducer.DialingPlan,
            EquipmentSelected: data.EquipmentReducer.EquipmentSelected,
            HostedPbxPlan: data.HostedPbxReducer.HostedPbxPlan,
        }
        //console.log("saveNewDataInCookie", newData);        
        setCartCookie(JSON.stringify(newData));

        if(Number(this.props.getAllItemsSummary()) > 0) {
            sendInBlueCartUpdated(newData);
        } else {
            sendInBlueCartDeleted();
        }
    }

    toggleSelectedNums(e) {
        e != undefined && e.stopPropagation();
        this.setState({
            ...this.state,
            isSelectedNumTableOpen: !this.state.isSelectedNumTableOpen,
        })
    }
    toggleSelectedEquipment(e) {
        e != undefined && e.stopPropagation();
        this.setState({
            ...this.state,
            isSelectedEquipmentTableOpen: !this.state.isSelectedEquipmentTableOpen,
        })
    }

    clearCart() {
        //clear cookie
        setCookie(CART_ITEMS_COOKIE_ID, "", -1);
        //reload page
        window.location.reload(false);
    }

    toggleExpandAll() {
        const { isAllExpanded } = this.state;
        //const { history } = this.props;
        //history.push(`/`);
        this.historyPush(`/`, "VoIP Dialing Shop");
        if(isAllExpanded) {
            //collapse
            this.setState({
                ...this.state,
                isAllExpanded: false,
                expandedKeys: []
            })
        } else {
            //expand
            this.setState({
                ...this.state,
                isAllExpanded: true,
                expandedKeys: APP_ENDPOINTS.map((item,i) => i)
            })
        }
    }

    //returns true if the "phone number" tab is opened and should show the "selected" button
    showNumbersSelected() {
        const { isAllExpanded, expandedKeys } = this.state;
        const { step } = this.props.match.params;
        const keys = isAllExpanded ? expandedKeys : [APP_ENDPOINTS.indexOf(step)];
        return keys.includes(0);
    }
    //returns true if the "equipment" tab is opened and should show the "selected" button
    showEquipmentSelected() {
        const { isAllExpanded, expandedKeys } = this.state;
        const { step } = this.props.match.params;
        const keys = isAllExpanded ? expandedKeys : [APP_ENDPOINTS.indexOf(step)];
        return keys.includes(4);
    }

    render() {
        const { data } = this.props;
        this.saveNewDataInCookie(data);

        const { isSelectedNumTableOpen, isSelectedEquipmentTableOpen, isAllExpanded, expandedKeys } = this.state;
        const { step/* = "did"*/ } = this.props.match.params;
        
        const DIDsStats = this.props.getPhoneNumbersSum();
        const HostedPbxStats = this.props.getHostedPbxSum();
        const DialingPlansStats = this.props.getDialingPlansSum();
        const SmsStats = this.props.getSmsSum();
        const EquipmentStats = this.props.getEquipmentSum();
        const EquipmentCount = this.props.getEquipmentCount();


        /*var Content = null;
        switch(step) {
            case "did": 
                Content = DIDs;
                break;
            case "hosted-pbx": 
                Content = HostedPBX;
                break;
            case "dialing-plan": 
                Content = DialingPlan;
                break;
            case "sms": 
                Content = SMS;
                break;
            case "equipment": 
                Content = Equipment;
                break;
            default : 
                Content = DIDs;
                break;
        }*/

        return (
            <div id="content">
                <div id="main-content">
                        <div id="steps">
                    <div id="steps-holder">
                            <div className="step-preview">
                                <NavLink to={`/${APP_BASENAME}/phone-numbers`}>
                                    Phone #'s
                                </NavLink>
                            </div>
                            {/* <div className="step-divider">
                                <i className="fas fa-chevron-right"></i>
                            </div> */}
                            <div className="step-preview">
                                <NavLink to={`/${APP_BASENAME}/hosted-pbx`}>
                                    Hosted PBX
                                </NavLink>
                            </div>
                            {/* <div className="step-divider">
                                <i className="fas fa-chevron-right"></i>
                            </div> */}
                            <div className="step-preview">
                                <NavLink to={`/${APP_BASENAME}/dialing-plan`}>
                                    Dialing Plan
                                </NavLink>
                            </div>
                            {/* <div className="step-divider">
                                <i className="fas fa-chevron-right"></i>
                            </div> */}
                            <div className="step-preview">
                                <NavLink to={`/${APP_BASENAME}/sms`}>
                                    SMS
                                </NavLink>
                            </div>
                            {/*<div className="step-divider">
                                <i className="fas fa-chevron-right"></i>
                            </div>*/}
                            <div className="step-preview">
                                <NavLink to={`/${APP_BASENAME}/equipment`}>
                                    IP Phones
                                </NavLink>
                            </div>
                        </div>
                    </div>
                    <div className="btns-holder" style={{justifyContent: "space-between", marginBottom: ".75rem"}}>
                        <div style={{fontSize: "1.25rem", padding: "0 .25rem", color: "#4bb8fb", cursor: "pointer"}}
                            onClick={() => this.toggleExpandAll()}>
                            <i className={`fas fa-${isAllExpanded ? "minus" : "plus"}`}></i>
                            {isAllExpanded ? " Collapse All" : " Expand All"}
                        </div>
                        {<div style={{fontSize: "1.25rem", padding: "0 .25rem", color: "#4bb8fb", cursor: "pointer"}}
                            onClick={() => this.clearCart()}>Reset
                        </div>}
                    </div>
                    <Collapse 
                        activeKey={isAllExpanded ? expandedKeys : [APP_ENDPOINTS.indexOf(step)]}
                        onlyOneOpened={!isAllExpanded}
                        id="main-collapse"
                        onChange={(keys) => this.onCollapseChange(keys)}
                        //defaultActiveKey={[APP_ENDPOINTS.indexOf(step)]}
                        items={[
                            {
                                headerTitle: 
                                    <HeaderTitle 
                                        titleLeft="Phone Numbers" 
                                        titleRight={
                                            DIDsStats.count > 0 ? 
                                            (
                                                <div>
                                                    {this.showNumbersSelected() === true && (
                                                        <span style={{borderBottom: "3px solid #4bb8fb"}} 
                                                            onClick={(e) => this.toggleSelectedNums(e)}>
                                                            Selected
                                                        </span>
                                                    )}
                                                    {` ${DIDsStats.count} Numbers, $${DIDsStats.price}`}
                                                </div>
                                            )
                                            :
                                            "0 Numbers Selected"} />,
                                headerClass: "main-header",
                                content: <DIDs isSelectedNumTableOpen={isSelectedNumTableOpen} 
                                    toggleSelectedNums={() => this.toggleSelectedNums(undefined)} />,
                            },
                            {
                                headerTitle: 
                                    <HeaderTitle 
                                        titleLeft="Hosted PBX"
                                        titleMiddle="Platform Selection"
                                        titleRight={HostedPbxStats ? `$${HostedPbxStats}` : ""}
                                    />,
                                headerClass: "main-header",
                                content: <HostedPBX />,
                            },
                            {
                                headerTitle: 
                                    <HeaderTitle 
                                        titleLeft="Dialing Plans" 
                                        titleMiddle="Outbound Usage"
                                        titleRight={DialingPlansStats ? `$${DialingPlansStats}` : ""}
                                    />,
                                headerClass: "main-header",
                                content: <DialingPlan />,
                            },
                            {
                                headerTitle: 
                                    <HeaderTitle 
                                        titleLeft="SMS" 
                                        titleRight={SmsStats ? `$${SmsStats}` : ""}
                                    />,
                                headerClass: "main-header",
                                content: <SMS />,
                            },
                            {
                                headerTitle: 
                                    /* <HeaderTitle 
                                        titleLeft="Equipment" 
                                        titleRight={EquipmentStats ? `$${EquipmentStats}` : ""}
                                    />, */
                                    <HeaderTitle 
                                        titleLeft="Equipment" 
                                        titleRight={
                                            EquipmentCount > 0 ? 
                                            (
                                                <div>
                                                    {this.showEquipmentSelected() === true && (
                                                        <span style={{borderBottom: "3px solid #4bb8fb"}} 
                                                            onClick={(e) => this.toggleSelectedEquipment(e)}>
                                                            Selected
                                                        </span>
                                                    )}
                                                    {` ${EquipmentCount} Device${EquipmentCount > 1 ? "s" : ""}, $${EquipmentStats}`}
                                                </div>
                                            )
                                            :
                                            "$0.00"} />,
                                headerClass: "main-header",
                                content: <Equipment isSelectedEquipmentTableOpen={isSelectedEquipmentTableOpen} 
                                    toggleSelectedEquipment={() => this.toggleSelectedEquipment(undefined)} />,
                            },
                        ]} 
                    />
                    <div>
                        <a href="https://voipdialing.com/terms-of-service">
                            <u><i>Terms of Use</i></u>
                        </a>
                    </div>

                    <Summary {...this.props} />
                    {/*<div id="step-info">
                        <Content />
                    </div>*/}
                </div>
                {/*<div id="checkout-holder">
                    <Checkout />
                </div>*/}
            </div>
        )
    }
}
const mapStateToProps = (state) => {
    return {
        data: state
    }
}
const mapDispatchToProps = (dispatch) => {
    return {
        getPhoneNumbersSum: () => dispatch(getPhoneNumbersSum()),
        getHostedPbxSum: () => dispatch(getHostedPbxSum()),
        getDialingPlansSum: () => dispatch(getDialingPlansSum()),
        getSmsSum: () => dispatch(getSmsSum()),
        getEquipmentSum: () => dispatch(getEquipmentSum()),
        getEquipmentCount: () => dispatch(getEquipmentCount()),
        setAddedDIDs: (data) => dispatch(setAddedDIDs(data)),
        setBulkPackagesSelected: (data) => dispatch(setBulkPackagesSelected(data)),
        setAddOnFeatures: (data) => dispatch(setAddOnFeatures(data)),
        setDialingPlan: (data) => dispatch(setDialingPlan(data)),
        setEquipmentSelected: (data) => dispatch(setEquipmentSelected(data)),
        setPbxPlan: (data) => dispatch(setPbxPlan(data)),
        getAllItemsSummary: () => dispatch(getAllItemsSummary()),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Home);